import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as S from './ChooseAdvertisers.styled';
import {
  ModalBase,
  ModalHeader,
  ModalFooter,
  ChooseBase,
  Buttons,
  ErrorComponent,
  ContentWrapp,
  Loader,
} from 'components';
import { useDebounce } from 'utils';
import { useToggleState } from './useToggleState';
import { Content } from './Content';
import { searchExcludeAPI } from 'services/searchExcludeAPI.service';

const ChooseAdvertisers = ({ title, selectedAdvertisers, setSelectedAdvertisers }) => {
  const [search, setSearch] = useState('');
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const debouncedValue = useDebounce(search, 1500);

  const [trigger, result] = searchExcludeAPI.useLazyFetchSerachAdvertisersQuery();
  const { data: foundedAdvetisers, isError, isFetching } = result;
  const {
    isActive,
    toggle,
    itemsToShow,
    handleSaveSelectedAdvertisers,
    handleSearchOnChange,
    handleClearSearchValue,
    restore,
    flag,
  } = useToggleState(
    selectedAdvertisers,
    foundedAdvetisers,
    setSearch,
    setSelectedAdvertisers,
    search,
    setIsOpen,
  );

  useEffect(() => {
    if (search.length > 3 && debouncedValue.length > 3) {
      trigger(search);
    }
  }, [debouncedValue]);

  const handleClose = () => {
    restore();
    dispatch(searchExcludeAPI.util.resetApiState());
    setSearch('');
    setIsOpen(false);
  };

  return (
    <>
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Advertisers
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ModalBase>
          <S.Box>
            <ModalHeader title={title} close={handleClose} />
            <S.Content>
              <ChooseBase.OneSection
                searchValue={search}
                searchOnChange={handleSearchOnChange}
                handleClearSearchValue={handleClearSearchValue}
                dontShowHeader
                title='Search Advertisers'
              >
                {isFetching && <Loader.Local delay={0.01} />}
                {isError && !isFetching > 0 && search.length > 3 && <ErrorComponent />}
                {!isFetching && (
                  <ContentWrapp
                    foundedItems={itemsToShow()}
                    search={search}
                    title='Use the search to choose a specific Advertisers.'
                  >
                    <Content
                      foundedAdvetisers={itemsToShow()}
                      search={search}
                      isActive={isActive}
                      toggle={toggle}
                    />
                  </ContentWrapp>
                )}
              </ChooseBase.OneSection>
            </S.Content>
            <ModalFooter
              saveButtonText='Apply'
              saveButtonOnClick={handleSaveSelectedAdvertisers}
              close={handleClose}
              saveButtonDisabled={flag.current}
            />
          </S.Box>
        </ModalBase>
      )}
    </>
  );
};

export default ChooseAdvertisers;
